import { dashboardApi } from '@/api';
import { DashboardRule, OptimisationBase } from '@/optimizer';

export type Campaigns = {
    id: string;
    name: string;
    status: string;
    startDate: Date;
    endDate: Date;
    budget: number;
    optimizationBase: OptimisationBase;
    customerRules: DashboardRule[];
    internalRules: DashboardRule[];
    disabledChannels?: string[];
};

export type CampaignsResponse = Campaigns[];

export const fetchCampaigns = async (projectId: string) =>
    dashboardApi<CampaignsResponse>({
        method: 'GET',
        url: `/customer-campaign/project/${projectId}/campaigns`,
    });
